<template>
  <div
    :class="{ 'isLoading': createWishlistIsLoading }"
  >
    <template v-if="isLoggedIn">
      <template v-if="!hasWishlists">
        <p class="text-center text-muted my-3">
          <i>
            Sie haben noch keine Wunschliste angelegt
          </i>
        </p>
      </template>
      <ul
        class="list-group"
        :class="{ 'wishlist-overview': overview }"
      >
        <template v-if="!overview">
          <li
            v-for="list in lists"
            :key="list.id"
            class="list-group-item d-flex align-items-center"
            :class="['wishlist_design_' + list.colorScheme, { 'activated': isOnWishlist(list.id) }]"
            @click="toggleVariationWishlist(list.id)"
          >
            <a
              :href="'/wunschliste/' + list.accessCode + '/'"
              class="btn mr-2 openListBtn"
              @click.stop
            ><i class="fa fa-pencil" /></a>

            <span>{{ list.name }}</span> <span>({{ numOnList(list.id) }})</span>

            <div
              class="HeartAnimation"
              :class="{ animate: isOnWishlist(list.id) }"
            />
          </li>
        </template>
        <template v-else>
          <li
            v-for="list in lists"
            :key="list.id"
            :class="'wishlist_design_' + list.colorScheme"
          >
            <a :href="'/wunschliste/' + list.accessCode + '/'">

              <span class="listInfo"><strong>{{ list.name }}</strong> <span>({{ numOnList(list.id) }})</span></span>
              <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="css-i6dzq1"
              ><polyline points="9 18 15 12 9 6" /></svg>
            </a>
          </li>
        </template>
        <li
          v-if="createWishlistIsLoading"
          class="newListLoading"
        >
          <a><i class="fa fa-spin fa-circle-o-notch mr-2" /> Wird geladen</a>
        </li>
      </ul>
      <a
        v-if="canCreateNewWishlist"
        class="createNew"
        @click="createNewWishlist()"
      >
        Neue Liste anlegen
      </a>
    </template>
    <template v-else>
      <p class="text-center">
        <i>Um Ihre Wunschlisten zu öffnen oder zu erstellen, <a
          class="btn btn-sm btn-bkm-inverted"
          @click="openLoginRegistration()"
        >melden Sie sich bitte an.</a></i>
      </p>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import loadWishlistModule from '../mixins/loadWishlistModule'
export default {
  name: 'BkWishlistlist',
  mixins: [loadWishlistModule],
  props: {
    overview: {
      type: Boolean,
      default: false
    },
    wishlistdata: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      lists: {
        type: Array,
        default: []
      }
    }
  },
  computed: {
    hasWishlists () {
      if (this.lists) { return (this.lists.length > 0) }
      return false
    },
    canCreateNewWishlist () {
      if (this.hasWishlists) { return (this.lists.length < 10) }
      return true
    },
    ...mapState({
      currentVariationId: state => state.bkwishlist.currentVariationId,
      userWishlists: state => state.bkwishlist.userWishlists
    }),
    ...mapGetters([
      'createWishlistIsLoading',
      'isLoggedIn'
    ])
  },
  watch: {
    userWishlists () {
      this.$nextTick(() => {
        this.lists = this.userWishlists
      })
    }
  },
  mounted () {
    this.initUserWishlists()
    this.setIsOverview()
    this.init()
  },
  methods: {
    init () {
      if (this.wishlistdata.length > 0) {
        this.lists = this.wishlistdata
        this.$store.dispatch('setUserWishlistsData', { data: this.wishlistdata })
      }
    },
    toggleVariationWishlist (listId) {
      if (this.isOnWishlist(listId)) {
        // remove
        this.$store.dispatch('removeFromBKWishList', { varId: parseInt(this.currentVariationId), wishlistId: parseInt(listId) })
          .then(
            response => { },
            error => { console.log(error) })
      } else {
        this.$store.dispatch('addToBKWishList', { varId: parseInt(this.currentVariationId), wishlistId: parseInt(listId) })
          .then(
            response => {
              document.dispatchEvent(new CustomEvent('onAddWishListId', { detail: { payload: parseInt(this.currentVariationId), variationId: parseInt(this.currentVariationId) } }))
            },
            error => {
              console.log(error)
            })
      }
    },
    numOnList (listId) {
      if (!this.lists || !this.lists.length) { return 0 }
      const itemList = this.lists.filter(wl => wl.id === listId)[0].wishlistItems
      return itemList.length
    },
    isOnWishlist (listId) {
      if (!this.lists || !this.lists.length) { return 0 }
      const itemList = this.lists.filter(wl => wl.id === listId)[0].wishlistItems
      return itemList.includes(this.currentVariationId)
    },
    isVariationInWishList () {
      if (!this.lists || !this.lists.length) { return 0 }
      return (this.lists.filter(list => list.wishlistItems.includes(this.currentVariationId)).length > 0)
    },
    createNewWishlist () {
      $('#add-to-wishlist-modal').modal('hide')
      $('#my-wishlists-modal').modal('hide')
      $('#new-wishlist-modal').modal('show')
    },
    openLoginRegistration () {
      this.loadComponent('login-modal')
      this.loadComponent('register-modal')
      $('#add-to-wishlist-modal').modal('hide')
      $('#my-wishlists-modal').modal('hide')
      $('#login').modal('show')
    },
    setIsOverview (b) {
      if (this.overview) {
        this.$store.dispatch('updateOverview', 1)
      } else { this.$store.dispatch('updateOverview', 0) }
    },
    ...mapActions([
      'initUserWishlists',
      'loadComponent'
    ])
  }
}
</script>
